import api from 'common/api'

type SurveyBody = {
  collegeSCID: number
  tags: string[]
  surveyType: 'unfollow' | 'follow' | 'reject' | 'enrollment'
  freeFormReason?: string
  referrer: string
  suggestedBy?: string[]
}

export const submitSurveyResults = ({
  collegeSCID,
  tags,
  surveyType,
  freeFormReason,
  suggestedBy,
  referrer,
}: SurveyBody) => {
  let body: SurveyBody = { collegeSCID, tags, surveyType, referrer }
  if (freeFormReason) body = { ...body, freeFormReason }
  if (suggestedBy) body = { ...body, suggestedBy }
  return api.post(`/api/micro_survey/submit`, body)
}
